import {Repository, createRepository} from '@/repositories/Base/Repository'

class ScaleRepository extends Repository {
    endpoint = 'tuevs/scales'

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }
}

export default new ScaleRepository()

export const create = createRepository(ScaleRepository)
